import { render, staticRenderFns } from "./EventClosedMain.vue?vue&type=template&id=5fe29571&scoped=true&"
import script from "./EventClosedMain.vue?vue&type=script&lang=js&"
export * from "./EventClosedMain.vue?vue&type=script&lang=js&"
import style0 from "./EventClosedMain.vue?vue&type=style&index=0&id=5fe29571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe29571",
  null
  
)

export default component.exports